import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './routes/Home'
import Users from './routes/Users'
import App from './App'
import Drawer from './components/common/Drawer'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
)
